import { useRef, useCallback } from "react";
const TARGET_ENTRY_RATIO = 0.5;
const resolvePointerX = (pointerCoordinates, collisionRect) => {
  var _a;
  return (_a = pointerCoordinates == null ? void 0 : pointerCoordinates.x) != null ? _a : collisionRect ? (collisionRect.left + collisionRect.right) / 2 : null;
};
const buildRects = (droppableContainers, order) => droppableContainers.map((container) => {
  const currentRect = container.rect.current;
  const rect = "translated" in currentRect && currentRect.translated ? currentRect.translated : currentRect;
  const orderIndex = order.indexOf(container.id.toString());
  if (!rect || orderIndex === -1) {
    return null;
  }
  return { id: container.id, rect, orderIndex };
}).filter((item) => !!item).sort((a, b) => a.rect.left === b.rect.left ? a.orderIndex - b.orderIndex : a.rect.left - b.rect.left);
const pickTargetId = (rects, pointerX, lastOverId) => {
  if (!rects.length) {
    return null;
  }
  if (rects.length === 1) {
    return rects[0].id;
  }
  const firstRect = rects[0];
  const lastRect = rects[rects.length - 1];
  if (pointerX < firstRect.rect.left) {
    return firstRect.id;
  }
  if (pointerX > lastRect.rect.right) {
    return lastRect.id;
  }
  const targetColIndex = rects.findIndex((rect) => rect.id === lastOverId);
  const current = rects[targetColIndex];
  if (pointerX >= current.rect.left && pointerX <= current.rect.right) {
    return current.id;
  }
  const next = rects[targetColIndex + 1];
  if (next && pointerX > current.rect.right) {
    const enterX = next.rect.left + (next.rect.right - next.rect.left) * TARGET_ENTRY_RATIO;
    if (pointerX >= enterX) {
      return next.id;
    }
  }
  const prev = rects[targetColIndex - 1];
  if (prev && pointerX < current.rect.left) {
    const enterX = prev.rect.right - (prev.rect.right - prev.rect.left) * TARGET_ENTRY_RATIO;
    if (pointerX <= enterX) {
      return prev.id;
    }
  }
  return current.id;
};
const useDndCollisionDetection = (draggableColumns) => {
  const lastOverId = useRef(null);
  const setLastOverId = useCallback((id) => {
    lastOverId.current = id;
  }, []);
  const collisionDetection = useCallback(
    ({ droppableContainers, collisionRect, pointerCoordinates }) => {
      const pointerX = resolvePointerX(pointerCoordinates, collisionRect);
      if (pointerX == null) {
        return lastOverId.current ? [{ id: lastOverId.current }] : [];
      }
      const rects = buildRects(droppableContainers, draggableColumns);
      const targetId = pickTargetId(rects, pointerX, lastOverId.current);
      if (targetId) {
        lastOverId.current = targetId;
        return [{ id: targetId }];
      }
      return [];
    },
    [draggableColumns]
  );
  return {
    collisionDetection,
    setLastOverId
  };
};
export default useDndCollisionDetection;
